import React from 'react';
import './TeamLogo.css';

interface TeamLogoProps {
  team: 'black' | 'white';
  size?: number;
}

const TeamLogo: React.FC<TeamLogoProps> = ({ team, size = 24 }) => {
  const logoPath = team === 'black' 
    ? '/logos/siyah-logo.png.png' 
    : '/logos/beyaz-logo.png.png';
  
  return (
    <img 
      src={logoPath} 
      alt={team === 'black' ? 'SİYAH' : 'BEYAZ'} 
      className="team-logo"
      style={{ width: size, height: size, objectFit: 'contain' }}
      onError={(e) => {
        // Logo yüklenemezse görünmez yap
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};

export default TeamLogo;

